import Gallery from "./Gallery";

export * from "./Gallery";

export default Gallery;
